export async function copyToClipboard(text: string): Promise<void> {
  if (navigator.clipboard && window.isSecureContext) {
    await navigator.clipboard.writeText(text)
  } else {
    const textArea = document.createElement('textarea')
    textArea.value = text
    textArea.style.position = 'fixed'
    textArea.style.opacity = '0'
    textArea.style.pointerEvents = 'none'
    textArea.style.zIndex = '-1'

    document.body.appendChild(textArea)
    textArea.focus()
    textArea.select()

    const manual = window.prompt('Copie o texto abaixo:', text)
    if (manual === null) {
      console.warn('Usuário cancelou a cópia manual.')
    }

    document.body.removeChild(textArea)
  }
}
